package Structs


data class DailySummery(
    val sales:Float = 15430f,
    val items: Float = 340f,
    val invoices:Float = 12f,
    val invoicesRegular:Float = 0f,
    val invoicesWithPayment:Float = 0f,
    val creditNotes:Float = 0f,
    val receiptsSum:Float = 5200f,
    val receiptsCount:Int = 5,
    val visits:Int = 22,
    // נתוני קופה חדשים:
    val cash:Float = 1200f,
    val checks:Float = 2500f,
    val credit:Float = 1500f,
    val transfer:Float = 0f,
    val taxDeduction:Float = 120f,
    val payments:List<InformationBase> = emptyList(),
    val taxes:List<InformationBase> = emptyList(),
    )
